export default __webpack_public_path__ + "static/media/classopedia.56d8e3a6.png";